import { render, staticRenderFns } from "./GraphDetail28.vue?vue&type=template&id=3cfcf8a3&scoped=true"
import script from "./GraphDetail28.vue?vue&type=script&lang=js"
export * from "./GraphDetail28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcf8a3",
  null
  
)

export default component.exports